module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded) ? _c('v-app', {
    class: ("app-content " + (_vm.Loader?'page-loader':'')),
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29284f94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 873
// module chunks = 76